module.exports = __webpack_public_path__ + "img/remove-medicine-icon.34f663e2.svg";